import React from 'react';
import { Divider } from '@mui/material';
import { Menu, MenuItem } from './style';
import { IContextualMenu } from './types';

const ContextualMenu: React.FC<IContextualMenu> = (props: IContextualMenu) => {
  const { actions, ...rest } = props;

  return (
    <Menu
      data-testid="contextualMenu"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      {...rest}
    >
      {actions.map(({ label, iconClasses, shouldHide, showDivider, onClick }) =>
        !shouldHide ? (
          <>
            {showDivider && <Divider />}
            <MenuItem key={label} onClick={onClick}>
              {!!iconClasses && <i className={iconClasses} />}
              {label}
            </MenuItem>
          </>
        ) : null
      )}
    </Menu>
  );
};

export default ContextualMenu;
